export default "__VITE_ASSET__D1nAK537__"